import TaiBaseWidget from "./base.widget.js";
/**
 *
 *
 * @class TermAndConditionWidget
 * @extends {TaiBaseWidget}
 */
class TermAndConditionWidget extends TaiBaseWidget {

    template() {
        const { uuid, title, placeholder, hint, defaultValue, code } = this.fieldModel;
        return `<div class="tai-form__item f-term" data-tai-field='term-and-condition'>
            <div class="tai-field">
                <div class="tai-holder">
                    <div class="tai-check__item">
                        <div class="tai-checkbox">
                            <input id="${uuid}" name="${code}" value="term-and-condition" type="checkbox"
                                class="tai-control" />
                            <label for="${uuid}"></label>
                        </div>
                        <label class="tai-value" for="${uuid}">
                            ${title}
                        </label>
                    </div>
                    <div class="tai-icon">
                        <span></span>
                    </div>
                </div>
            </div>
            <div class="tai-error">
                <span class="f-msg"></span>
            </div>
            <div class="tai-hint">
                <span class="f-hint">${hint}</span>
            </div>
        </div>`
    }

    getValue() {
        return Array.from(this.inputControls.filter(el => el.checked)).map(item => item.value);
    }
}

export default TermAndConditionWidget;